import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, Link, Outlet } from 'react-router-dom';
import HomePage from './HomePage';
import HowToPlay from './HowToPlay';
import NotFoundPage from './NotFoundPage';
import PlayPage from './PlayPage';
import MainPage from './MainPage';
import TwitchPage from './TwitchPage';
import Stats from './StatsPage';
import CodexPage from './CodexPage';
import './App.css';
import GooglePage from './GooglePage';
import Auth0Page from './Auth0Page';
import PrivacyPolicy from './PrivacyPage';
import TermsOfService from './TermsPage';
import LogoutPage from './LogoutPage';
import BuddyPage from './BuddyPage';
import HandHistoryPage from './HandHistoryPage';
import SharedHandPage from './SharedHandPage';
import SubscribePage from './SubscribePage';
import ChartsPage from './ChartsPage';
import SessionsPage from './pages/SessionsPage';
import SubscriptionCompletePage from './SubscriptionCompletePage';
import LearnPage from './LearnPage';
import TrainPage from './TrainPage';
import PokerHand from './PokerHand';
import HandNotesPage from './HandNotesPage';
import SessionListPage from './SessionListPage';
import SessionHandsPage from './SessionHandsPage';
import SessionAnalysisPage from './SessionAnalysisPage';
import PlaygroundPage from '../pages/PlaygroundPage/PlaygroundPage';
import HandReplayerPage from '../pages/HandReplayerPage';
import SimpleReplayerPage from '../pages/SimpleReplayerPage';
import PlayerProfilePage from '../app/pages/PlayerProfilePage';
import MobileLayout from '../mobile/MobileLayout';
import MobileHome from '../mobile/pages/HomePage';
import MobileMacros from '../mobile/pages/MacrosPage';
import MobileProgram from '../mobile/pages/ProgramPage';
import MobilePhysique from '../mobile/pages/PhysiquePage';
import MobileChat from '../mobile/pages/ChatPage';
import AnxietyLandingPage from '../pages/landing/AnxietyLandingPage';
import InjuryLandingPage from '../pages/landing/InjuryLandingPage';
import DreamPhysiqueLandingPage from '../pages/landing/DreamPhysiqueLandingPage';
import GenericLandingPage from '../pages/landing/GenericLandingPage';

// Define LoadingPage component here
const LoadingPage = () => {
  return <div>Loading...</div>;
};

interface AppState {
  initialized: boolean;
};

class App extends React.Component<{}, AppState> {
  constructor(props = {}) {
    super(props);

    this.state = {
      initialized: false
    }
  }

  componentDidMount(): void {
    this.load();

    // document.addEventListener('keydown', (event)=>{
    //   console.log(event.key == 'd');
    //   if(event.key == 'd')
    //     Network.disconnect();
    //   if(event.key == 'c')
    //     Network.connect();
    // });
  }

  async load() {
    // Database initialization removed
    this.setState({initialized: true});
  }

  onUpdate() {
    this.forceUpdate();
  }
  
  render() {
    if (!this.state.initialized) {
      return <LoadingPage />;
    }

    return (
      <Router>
        <Routes>
          {/* Landing pages at top-level so legacy header is not shown */}
          <Route path="/" element={<GenericLandingPage />} />
          <Route path="/campaign/anxiety" element={<AnxietyLandingPage />} />
          <Route path="/campaign/injury" element={<InjuryLandingPage />} />
          <Route path="/campaign/dream-physique" element={<DreamPhysiqueLandingPage />} />
          
          <Route path="/mobile" element={<MobileLayout />}>
            <Route index element={<MobileHome />} />
            <Route path="macros" element={<MobileMacros />} />
            <Route path="program" element={<MobileProgram />} />
            <Route path="physique" element={<MobilePhysique />} />
            <Route path="chat" element={<MobileChat />} />
          </Route>

          <Route path="/buddy" element={<MainPage />}>
            <Route index element={<BuddyPage />} />
          </Route>
          <Route path="/how-to-play" element={<MainPage />}>
            <Route index element={<HowToPlay />} />
          </Route>
          <Route path="/learn" element={<MainPage />}>
            <Route index element={<LearnPage />} />
          </Route>
          <Route path="/train" element={<MainPage />}>
            <Route index element={<TrainPage />} />
          </Route>
          <Route path="/visualiser" element={<MainPage />}>
            <Route index element={<PokerHand />} />
          </Route>
          <Route path="/handnotes" element={<MainPage />}>
            <Route index element={<HandNotesPage />} />
          </Route>
          <Route path="/codex" element={<MainPage />}>
            <Route index element={<CodexPage />} />
          </Route>
          <Route path="/play" element={<MainPage />}>
            <Route index element={<PlayPage />} />
          </Route>
          <Route path="/twitch" element={<MainPage />}>
            <Route index element={<TwitchPage onUpdate={()=>this.onUpdate()}/>} />
          </Route>
          <Route path="/stats" element={<MainPage />}>
            <Route index element={<Stats/>} />
          </Route>
          <Route path="/google" element={<MainPage />}>
            <Route index element={<GooglePage onUpdate={()=>this.onUpdate()} />} />
          </Route>
          <Route path="/auth0" element={<MainPage />}>
            <Route index element={<Auth0Page onUpdate={()=>this.onUpdate()} />} />
          </Route>
          <Route path="/privacy-policy" element={<MainPage />}>
            <Route index element={<PrivacyPolicy />} />
          </Route>
          <Route path="/terms-of-service" element={<MainPage />}>
            <Route index element={<TermsOfService />} />
          </Route>
          <Route path="/history/user/:playfabId/sessions" element={<MainPage />}>
            <Route index element={<SessionListPage />} />
          </Route>
          <Route path="/history/user/:playfabId/sessions/:sessionId" element={<MainPage />}>
            <Route index element={<SessionHandsPage />} />
          </Route>
          <Route path="/session-analysis/:playfabId/:sessionId" element={<MainPage />}>
            <Route index element={<SessionAnalysisPage />} />
          </Route>
          <Route path="/history/user/:playfabId/hand/:handId" element={<MainPage />}>
            <Route index element={<HandHistoryPage />} />
          </Route>
          <Route path="/sessions" element={<MainPage />}>
            <Route index element={<SessionsPage />} />
          </Route>
          <Route path="/charts" element={<MainPage />}>
            <Route index element={<ChartsPage />} />
          </Route>
          <Route path="/subscribe" element={<MainPage />}>
            <Route index element={<SubscribePage />} />
          </Route>
          <Route path="/subscription_complete" element={<MainPage />}>
            <Route index element={<SubscriptionCompletePage />} />
          </Route>
          <Route path="/playground" element={<MainPage />}>
            <Route index element={<PlaygroundPage />} />
          </Route>
          <Route path="/hand-replayer" element={<MainPage />}>
            <Route index element={<HandReplayerPage />} />
          </Route>
          <Route path="/hand-review" element={<MainPage />}>
            <Route index element={<SimpleReplayerPage />} />
          </Route>
          <Route path="/hand-review/user/:playfabId/hand/:handId" element={<MainPage />}>
            <Route index element={<SimpleReplayerPage />} />
          </Route>
          <Route path="/profile" element={<MainPage />}>
            <Route index element={<PlayerProfilePage />} />
          </Route>
        </Routes>
      </Router>
    );
  }
}

export default App;